import { render, staticRenderFns } from "./wave.vue?vue&type=template&id=779ca6b6&scoped=true&"
import script from "./wave.vue?vue&type=script&lang=js&"
export * from "./wave.vue?vue&type=script&lang=js&"
import style0 from "./wave.vue?vue&type=style&index=0&id=779ca6b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779ca6b6",
  null
  
)

export default component.exports